import { render, staticRenderFns } from "./ExtractionTemplateModifiedStatusChip.vue?vue&type=template&id=c8073e42&"
import script from "./ExtractionTemplateModifiedStatusChip.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplateModifiedStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
